// Domain types for the Admin Payment Credits MSPA.

// A row in the payment credits list table.
export interface PaymentCredit {
  id: string;
  paymentSource: string;
  description: string;
  criteria: string;
}

// Controlled values for the payment credit create/edit form.
export interface PaymentCreditFormValues {
  paymentSource: string;
  description: string;
  criteria: string;
}

export const emptyPaymentCreditForm: PaymentCreditFormValues = {
  paymentSource: "",
  description: "",
  criteria: "",
};
